import React from "react";
import Loader from "./Loader";

const OverlayLoader = () => (
    <div style={{
        position: 'fixed', 
        margin: '0 auto', 
        left: 0, 
        right: 0,
        top: 0,
        zIndex: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        height: 100 + '%',
    }}>
        <div style={{ position: 'absolute', top: '50%', left: '50%'}}>
            <Loader/>
        </div>
    </div>
);

export default OverlayLoader;
